// @core/api/endpoints/secret/create_encryption_key.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateEncryptionKeyRequest,
  EncryptionKeyResponse,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Create encryption key
 * Creates a new named encryption key in the Transit engine. Key material is generated server-side and never exposed unless the key is marked exportable.
 */
export async function CreateEncryptionKey(
  engine_id: string,
  data: CreateEncryptionKeyRequest,
  options?: RequestOptions
): Promise<EncryptionKeyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/transit/keys`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  const requestOptions = options;
  return client.post<EncryptionKeyResponse>(requestPath, data, requestOptions);
}
